import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import OptimizeImagesService from 'services/OptimizeImages.service';
import LanguageService from 'services/Language.service';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import moment from 'moment';

import { injectIntl } from 'react-intl';
import styles from './ArticleNoteMd.module.scss';

@injectIntl
export default class ArticleNoteMdComponent extends Component {
  static propTypes = {
    news: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      name: props.name,
      date: props.date,
      background: props.background
    };
  }

  currentLanguage = LanguageService.getLang();

  renderCategories() {
    const { categoryPath } = this.props;
    const categories = _get(this.props, categoryPath);

    return categories.map((taxonomy, index) => {
      return (
        <span key={index} className={styles.ArticleNoteMdCategoryValueOption}>
          {taxonomy.name}
        </span>
      );
    });
  }

  render() {
    const {
      className,
      messages,
      categorySlug,
      viewWithOnlyNews,
      news
    } = this.props;
    const {
      title,
      publicationDate,
      photo: { url },
      slug
    } = news;
    const year = moment(publicationDate).format('YYYY');

    return (
      <div className={`${styles.ArticleNoteMd} ${className}`}>
        <Link to={`${categorySlug[this.currentLanguage]}/${year}/${slug}`}>
          {url && (
            <div
              className={styles.ArticleNoteMdImage}
              style={{
                backgroundImage: `url(${OptimizeImagesService.adjustImageSize(
                  url
                )})`
              }}
            />
          )}
        </Link>
        <div
          className={
            url ? styles.ArticleNoteMdBox : styles.ArticleNoteMdBoxNoImage
          }
        >
          <Link to={`${categorySlug[this.currentLanguage]}/${year}/${slug}`}>
            <div className={styles.ArticleNoteMdTitle}>
              <span>{title}</span>
            </div>
            <div className={styles.ArticleNoteMdDate}>
              {moment(publicationDate).format('LL')}
            </div>
          </Link>
          <div className={styles.ArticleNoteMdCompanyInfo}>
            {!viewWithOnlyNews && (
              <>
                <span className={styles.ArticleNoteMdCategoryLabel}>
                  {this.props.intl.formatMessage(messages.category)}
                </span>
                <span className={styles.ArticleNoteMdCategoryValue}>
                  {this.renderCategories()}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArticlesPage/components/ArticleNoteMd/AricleNoteMd.js